import { useState } from 'react';
import { Link as ReactRouterLink } from 'react-router-dom';
import { Grid, Paper, Tooltip } from '@mui/material';

import { InfoField, Typography, Link, NO_DATA_PLACEHOLDER } from '@occc/ui-design-system';

import { routeCreator as campaignRouteCreator } from '@occc-app/routes/Campaign/utils';

import { ExternalLoyaltyManualOfferDetails } from '../../../tobacco-api-offers.types';
import { formatStates, VISIBLE_STATES_COUNT } from '../../tobacco-api-offers-page/tobacco-api-offers.utils';
import { UpcListDialog } from './upc-list-dialog.component';

type OfferEligibilityCardProps = {
  offer: ExternalLoyaltyManualOfferDetails;
  runDates: string;
};

export const OfferEligibilityCard = ({ offer, runDates }: OfferEligibilityCardProps) => {
  const [upcDialogOpen, setUpcDialogOpen] = useState(false);

  return (
  <Paper
    variant='outlined'
    sx={{
      p: 3,
      borderRadius: 2,
      boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.25)',
      borderColor: 'transparent',
    }}
  >
    <Typography variant='subtitle1' fontWeight='medium'>
      External Campaign ID (Loyalty Fund Promotion Code)
    </Typography>
    <Typography variant='body1' sx={{ mb: 3 }}>
      {offer.externalCampaignId || NO_DATA_PLACEHOLDER}
    </Typography>

    <Typography variant='subtitle1' fontWeight='medium' sx={{ mb: 2 }}>
      Eligibility
    </Typography>

    <Grid container spacing={3}>
      <Grid item xs={12} sm={6} md={3}>
        <InfoField
          label='Eligible States'
          disableTypography
          value={
            offer.states.length > VISIBLE_STATES_COUNT ? (
              <Tooltip title={offer.states.join(', ')} arrow placement='top'>
                <Typography variant='body1' sx={{ width: 'fit-content' }}>
                  {formatStates(offer.states)}
                </Typography>
              </Tooltip>
            ) : (
              <Typography variant='body1'>{formatStates(offer.states)}</Typography>
            )
          }
        />
      </Grid>
      <Grid item xs={12} sm={6} md={3}>
        <InfoField label='Start and End Date' value={runDates} />
      </Grid>
      <Grid item xs={12} sm={6} md={3}>
        <InfoField label='Included Stores' value={`${offer.storeCount} Stores`} />
      </Grid>
      <Grid item xs={12} sm={6} md={3}>
        <InfoField
          label='Eligible UPCs'
          disableTypography
          value={
            <Link component='button' variant='body1' color='primary' onClick={() => setUpcDialogOpen(true)}>
              View all UPCs
            </Link>
          }
        />
        <UpcListDialog
          open={upcDialogOpen}
          onClose={() => setUpcDialogOpen(false)}
          offerUuid={offer.uuid}
        />
      </Grid>
    </Grid>

    <Grid container spacing={3} sx={{ pt: 3 }}>
      <Grid item xs={12} sm={6} md={3}>
        <InfoField
          label='Offer'
          value={offer.name || NO_DATA_PLACEHOLDER}
        />
      </Grid>
      <Grid item xs={12} sm={6} md={3}>
        <InfoField
          label='Activate Offer'
          disableTypography
          value={
            offer.activateCampaignId && offer.activateOfferId ? (
              <Link
                component={ReactRouterLink}
                to={campaignRouteCreator.offerDetails(offer.activateCampaignId, offer.activateOfferId)}
                variant='body1'
                color='primary'
              >
                View Offer In Activate
              </Link>
            ) : (
              NO_DATA_PLACEHOLDER
            )
          }
        />
      </Grid>
    </Grid>
  </Paper>
  );
};
